import React from 'react';
import SaveIcon from '@mui/icons-material/Save';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

const containerStyle = {
    position: 'absolute',
    top: '0',
    right: '2px',
    zIndex: '999',
    color: 'Tomato',
};

export default function SaveButton(props) {
    const { t } = useTranslation();
    const disabled = props.disabled;
    const hasChanges = props.hasChanges;
    const onSubmit = props.onSubmit;
    const saving = props.saving;
    const text = props.text ? props.text : t('buttons.save');
    const name = props.name ? props.name : 'tallenna';

    return (
        <Button
            variant="contained"
            color="primary"
            name={name}
            onClick={onSubmit}
            disabled={disabled}
            startIcon={saving ? <CircularProgress color={'secondary'} size={'1rem'} /> : <SaveIcon />}>
            {text}
            {!disabled && !!hasChanges && (
                <div style={containerStyle}>
                    <i className="fas fa-exclamation-circle"></i>
                </div>
            )}
            &nbsp;
        </Button>
    );
}
